import { Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {} from "assets/jss/material-dashboard-react.js";
import CardIndicator from "components/CardIndicator";
import MaterialTable from "components/MaterialTable.js";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Actions from "redux/actions";
import { appartementDashColumns } from "utils/columns";

class Dashboard extends React.Component {
  componentDidMount() {
    this.props.dispatch(Actions.getAppartements());
  }

  render() {
    const c = this.props.classes;
    const appartements = this.props.appartements || [];
    return (
      <div className={c.container}>
        <Paper style={{ padding: 20 }}>
          <h2 className={c.title}>Appartements</h2>
          <div className="row">
            <CardIndicator
              bgcolor="#2d6a4f"
              icon="home_work"
              title="Total"
              data={appartements.length}
            />
            <CardIndicator
              bgcolor="#40916c"
              icon="perm_contact_calendar"
              title="Loue"
              data={appartements.filter((a) => (a.locataires || []).length).length}
            />
            <CardIndicator
              bgcolor="#52b788"
              icon="local_offer"
              title="Vacant"
              data={
                appartements.filter((a) => !a.wip && !(a.locataires || []).length)
                  .length
              }
            />
            <CardIndicator
              bgcolor="#74c69d"
              icon="warning"
              title="En Travaux"
              data={appartements.filter((a) => a.wip).length}
            />
          </div>
        </Paper>

        <Paper style={{ padding: 20, marginTop: 20 }}>
          <h2 className={c.title}>Appartements en preavis ou vacants</h2>
          <MaterialTable
            title=""
            isLoading={!this.props.appartements}
            columns={appartementDashColumns}
            data={appartements.filter((a) =>
              (a.locataires || []).length === 0
                ? true
                : (a.locataires || []).every(
                    ({ Dossier }) =>
                      (Dossier?.dateFinBail &&
                        moment().isAfter(Dossier.dateFinBail)) ||
                      (Dossier?.dateDebutPreavis &&
                        Dossier?.dateFinPreavis &&
                        moment().isBetween(
                          moment(Dossier.dateDebutPreavis),
                          moment(Dossier.dateFinPreavis)
                        ))
                  )
            )}
            actions={[
              {
                icon: "edit",
                tooltip: "Modifier l'appartement",
                onClick: (event, rowData) =>
                  this.props.history.push(`/appartements/${rowData.id}/edit`),
              },
              {
                icon: "remove_red_eye",
                tooltip: "Voir les details de l'appartement",
                onClick: (event, rowData) =>
                  this.props.history.push(`/appartements/${rowData.id}`),
              },
            ]}
            onRowClick={(event, rowData) =>
              this.props.history.push(`/appartements/${rowData.id}`)
            }
            options={{
              filtering: true,
              pageSize: 5,
              actionsColumnIndex: -1,
            }}
          />
        </Paper>
      </div>
    );
  }
}

const styles = () => ({
  title: { marginTop: 10, barginBottom: 30 },
});

const mapStateToProps = (state) => ({
  appartements: state.reducer.appartements,
  currentUser: state.reducer.currentUser,
});

export default withRouter(withStyles(styles)(connect(mapStateToProps)(Dashboard)));
